import React from "react";
import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";

export interface ProgressCircleProps {
  percent: number;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

const CircleOuter = styled(Box)<{ percent: number; size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  background: ${({ theme, percent }) => `conic-gradient(
    ${theme.palette.primary.main} ${percent * 3.6}deg,
    ${theme.palette.background.neutralDark} ${percent * 3.6}deg
  )`};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 300ms;
`;

const CircleInner = styled(Box)<{ size: number; strokeWidth: number }>`
  width: ${({ size, strokeWidth }) => size - strokeWidth * 2}px;
  height: ${({ size, strokeWidth }) => size - strokeWidth * 2}px;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.background.paper};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProgressCircle = ({
  percent,
  size = 48,
  strokeWidth = 4,
  className,
}: ProgressCircleProps) => {
  return (
    <CircleOuter percent={percent} size={size} className={className}>
      <CircleInner size={size} strokeWidth={strokeWidth}>
        <Typography variant="caption" color="text.secondary">
          {percent}%
        </Typography>
      </CircleInner>
    </CircleOuter>
  );
};
